/** File is auto-generated by TypeWriter, a plug-in for Visual Studio. Modifications will be overridden when the template is rendered */
import { AxiosUtil } from 'src/utils';
import CurrentUserDTO from "src/models/generated/CurrentUserDTO";
import TimeIntervalDTO from "src/models/generated/TimeIntervalDTO";
import UploadMediaDTO from "src/models/generated/UploadMediaDTO";
import UserProfileDTO from "src/models/generated/UserProfileDTO";
import WorkingHoursRequest from "src/models/generated/WorkingHoursRequest";

export class AccountController {
    /**
     * get: /api/Account/me
     */
    public me() {
        const route = `api/Account/me`;
        return AxiosUtil.get<CurrentUserDTO>(route, CurrentUserDTO.create);
    }

    /**
     * get: /api/Account/profile
     */
    public getCurrentUserProfile() {
        const route = `api/Account/profile`;
        return AxiosUtil.get<UserProfileDTO>(route, UserProfileDTO.create);
    }

    /**
     * post: /api/Account/profile/update
     */
    public updateCurrentUserProfile(userProfile: UserProfileDTO) {
        const route = `api/Account/profile/update`;
        return AxiosUtil.post<UserProfileDTO, UserProfileDTO>(route, userProfile, UserProfileDTO.create);
    }

    /**
     * get: /api/Account/profile/workingHours?timeZoneOffset=${encodeURIComponent(timeZoneOffset)}
     */
    public getCurrentUserProfileWorkingHours(timeZoneOffset: string) {
        const route = `api/Account/profile/workingHours?timeZoneOffset=${encodeURIComponent(timeZoneOffset)}`;
        return AxiosUtil.get<TimeIntervalDTO[]>(route, items => items.map(TimeIntervalDTO.create));
    }

    /**
     * put: /api/Account/profile/workingHours/update
     */
    public updateCurrentUserProfileWorkingHours(request: WorkingHoursRequest) {
        const route = `api/Account/profile/workingHours/update`;
        return AxiosUtil.put<TimeIntervalDTO[], WorkingHoursRequest>(route, request, items => items.map(TimeIntervalDTO.create));
    }

    /**
     * post: /api/Account/profile/update/email
     */
    public updateUserEmail(userProfile: UserProfileDTO) {
        const route = `api/Account/profile/update/email`;
        return AxiosUtil.post<any, UserProfileDTO>(route, userProfile);
    }

    /**
     * post: /api/Account/profile/update/phone
     */
    public updateUserPhone(userProfile: UserProfileDTO) {
        const route = `api/Account/profile/update/phone`;
        return AxiosUtil.post<any, UserProfileDTO>(route, userProfile);
    }

    /**
     * post: /api/Account/profile/confirm/email
     */
    public confirmUserEmail(userProfile: UserProfileDTO) {
        const route = `api/Account/profile/confirm/email`;
        return AxiosUtil.post<any, UserProfileDTO>(route, userProfile);
    }

    /**
     * post: /api/Account/profile/confirm/phone
     */
    public confirmUserPhone(userProfile: UserProfileDTO) {
        const route = `api/Account/profile/confirm/phone`;
        return AxiosUtil.post<any, UserProfileDTO>(route, userProfile);
    }

    /**
     * post: /api/Account/profile/upload/profilePicture
     */
    public uploadProfilePicture(model: UploadMediaDTO) {
        const route = `api/Account/profile/upload/profilePicture`;
        return AxiosUtil.postForm<any, UploadMediaDTO>(route, model);
    }

    /**
     * delete: /api/Account/media?entityId=${encodeURIComponent(entityId)}
     */
    public deleteMedia(entityId: string) {
        const route = `api/Account/media?entityId=${encodeURIComponent(entityId)}`;
        return AxiosUtil.delete<any>(route);
    }

    /**
     * post: /api/Account/makePublic
     */
    public makePublic() {
        const route = `api/Account/makePublic`;
        return AxiosUtil.post<any, null>(route, null);
    }
}

export default new AccountController();
